"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _lodash = require("lodash");
var _utils = require("../utils");
var _ = require("../../../");
var _Message = _interopRequireDefault(require("./Message"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var MessageList = function MessageList(_ref) {
  var client = _ref.client;
  var _useChannelStateConte = (0, _streamChatReact.useChannelStateContext)(),
    mutes = _useChannelStateConte.mutes,
    channelMessages = _useChannelStateConte.messages;
  var messages = (0, _react.useMemo)(function () {
    return (0, _lodash.reject)(channelMessages, function (message) {
      return (0, _utils.isMessageFromMutedUser)(message, mutes) || (0, _utils.isMuteMessageFromOtherUser)(message, client.user);
    });
  }, [mutes, channelMessages, client.user]);
  (0, _utils.useFirstChannelUnreadThreadOpen)();
  return /*#__PURE__*/_react.default.createElement(_streamChatReact.MessageList, {
    Message: _Message.default,
    messageActions: _.ALLOWED_MESSAGE_ACTIONS.GROUP,
    messages: messages,
    onlySenderCanEdit: true,
    hideDeletedMessages: true
  });
};
var _default = MessageList;
exports.default = _default;